import { css } from '@emotion/css';
import { LightBlueOXIcon, LightBlueSleepyIcon, LightBlueSurprisedIcon, LightBlueXOIcon, LightBlueXXIcon, LightBlueXXSadIcon, } from './icons';
export const ErrorIconTypes = {
    SurfaceIssue: LightBlueXXSadIcon,
    Critical400Failure: LightBlueXXIcon,
    InvalidMerchandisingData: LightBlueXOIcon,
    InvalidProductData: LightBlueOXIcon,
    Critical500Failure: LightBlueSleepyIcon,
    Default: LightBlueSurprisedIcon,
};
export const ErrorIconColor = {
    ProductTribe: css `
        .color-element {
            fill: #f46a1c;
        }
    `,
    ProductSetupTeam: css `
        .color-element {
            fill: #cb36ff;
        }
    `,
    DesignTechTribe: css `
        .color-element {
            fill: #36b7ff;
        }
    `,
    MerchTechTribe: css `
        .color-element {
            fill: #ecc30b;
        }
    `,
    Default: css `
        .color-element {
            fill: #36b7ff;
        }
    `,
};
//# sourceMappingURL=ErrorConstants.js.map